import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = [{
  url: 'https://cdn.magicpatterns.com/uploads/or3QLCoHaZVoZZchmGcHwR/screencapture-app-useflowsense-app-2025-12-09-23_52_57.png',
  alt: 'Flowsense Dashboard - Overview of Klaviyo flow performance'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/evPx8JSy88YrwT3fze947X/screencapture-app-useflowsense-app-flows-2025-12-09-23_53_10.png',
  alt: 'Flowsense Flows - Analyze and optimize your Klaviyo flows'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/p9ticVhsWvVU2wjPgLNuKd/screencapture-app-useflowsense-app-flows-flow-1-2025-12-09-23_53_45.png',
  alt: 'Flowsense Flow Details - Detailed flow analysis and recommendations'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/6WvkSxbPAUzuCh74zesyqj/screencapture-app-useflowsense-app-recommendations-2025-12-10-00_04_22.png',
  alt: 'Flowsense Recommendations - AI-powered suggestions to improve flow performance'
}];
export function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const goToPrevious = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  return <div className="relative w-full rounded-lg shadow-2xl overflow-hidden bg-gray-900 group" data-id="element-95">
      <div className="relative aspect-video" data-id="element-96">
        <img src={images[currentIndex].url} alt={images[currentIndex].alt} className="w-full h-full object-cover object-top" loading="lazy" data-id="element-97" />
      </div>

      {/* Navigation Buttons */}
      <button onClick={goToPrevious} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 rounded-full p-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Previous image" data-id="element-98">
        <ChevronLeft className="h-6 w-6" data-id="element-99" />
      </button>
      <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 rounded-full p-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Next image" data-id="element-100">
        <ChevronRight className="h-6 w-6" data-id="element-101" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2" data-id="element-102">
        {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-white w-8' : 'bg-white/50'}`} aria-label={`Go to image ${index + 1}`} data-id="element-103" />)}
      </div>
    </div>;
}